import { render, staticRenderFns } from "./swiper_first_scend_tab01.vue?vue&type=template&id=37ad1267"
import script from "./swiper_first_scend_tab01.vue?vue&type=script&lang=js"
export * from "./swiper_first_scend_tab01.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports